<ion-content>
  <header>
    <app-page-header class="size-header">
      <h1 translate>news.title.title</h1>
      <div class="search-bar-area" centered>
        <ion-input
          #searchInput
          autocomplete="off"
          (ionChange)="search()"
          [(ngModel)]="filter.Search"
          class="search_bar"
          placeholder="{{ 'common.search' | translate }}"
          [disabled]="disabledSearch"></ion-input>
      </div>
    </app-page-header>
  </header>

  <main>
    <div>
      <ion-grid class="gap-dashboards">
        <ion-row *ngIf="!Loading">
          <ion-col>
            <div class="main_banner">
              <app-news-card-list
                title="{{ 'news.title.highlights' | translate }}"
                [route]="filter.Search ? 'news/highlights/null/' + filter.Search : 'news/highlights/null/undefined'"
                [color]="'var(--ion-color-primary)'"
                [hidden]="Loading"
                [moreButton]="false"
                [dashboard]="true"
                [shadow]="false"
                [highlight]="newsHighlight.length > 1 ? false : true"
                class="justify-center">
                <div data class="loh wrap m fit">
                  <ion-row class="full-height">
                    <div class="highlights-container">
                      <div
                        [class]="biggestHighlight.internVideo ? 'flex-center padding' : 'flex-center padding margin-media-top'"
                        class="bigger-highligth-container">
                        <app-post-banner
                          [news_data]="biggestHighlight"
                          *ngIf="newsHighlight.length > 0"
                          [routerLink]="['details/null/', biggestHighlight.id]"
                          [(news_data)]="biggestHighlight"
                          [class]="
                            biggestHighlight.internVideo
                              ? 'full-width app_banner z-index'
                              : biggestHighlight.image[translate.currentLang]
                                ? 'full-width app_banner z-index'
                                : 'full-width full-height-media z-index'
                          "></app-post-banner>
                      </div>
                      <div class="padding smaller-highlight-container">
                        <div class="">
                          <div data *ngFor="let news of newsHighlight | slice: 0 : 2; let i = index">
                            <app-post-medium
                              class="medium-post"
                              [routerLink]="['details/null/', newsHighlight[i].id]"
                              [news_data]="newsHighlight[i]"
                              [dashboard]="true"
                              [fill_width]="true">
                            </app-post-medium>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ion-row>
                </div>
              </app-news-card-list>
            </div>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="!Loading" class="gap-dashboards">
          <ion-col size="12" *ngFor="let editorial of editorials; let y = index">
            <app-news-card-list
              title="{{ editorial.name | i18n }}"
              [icon]="editorial.imageIcon!"
              [route]="['news/', editorial.id, null, filter.Search]"
              [redirect]="editorial.id == 'a4acd8ee-0e95-415a-8c8e-0f406c319362' ? editorial.link : null"
              [color]="editorial.FilterColor"
              [labelColor]="editorial.labelColor"
              [topbar]="true"
              [hidden]="Loading"
              [recents]="false"
              [moreButton]="news[y].length < 3 ? false : true"
              [dashboard]="true"
              [border]="true"
              [viewMore]="editorial.id != EditorialCaminhosId">
              <div data>
                <ion-row>
                  <ion-col class="mb p0">
                    <div *ngIf="y < 1">
                      <!-- caminhos intencionais -->

                      <ion-row>
                        <ion-col
                          data
                          [size]="12"
                          [sizeMd]="newsCaminhosIntencionais.length < 3 ? 12 / newsCaminhosIntencionais.length : 3"
                          *ngFor="let item of newsCaminhosIntencionais | slice: 0 : 4; let i = index">
                          <!-- Quando for o editorial Caminhos, usamos o wrapper para redirect -->
                          <ng-container *ngIf="editorial.id === EditorialCaminhosId; else normalPostA">
                            <ng-container *ngIf="newsCaminhosIntencionais.length > 0; else caminhosLoadingA">
                              <app-post-medium-redirect
                                [link]="newsCaminhosIntencionais[i].redirectLink"
                                [ariaLabel]="newsCaminhosIntencionais[i].title">
                                <app-post-medium class="medium-post p0" [news_data]="newsCaminhosIntencionais[i]"> </app-post-medium>
                              </app-post-medium-redirect>
                            </ng-container>
                          </ng-container>
                          <ng-template #caminhosLoadingA>
                            <app-post-medium-loading class="medium-post"></app-post-medium-loading>
                          </ng-template>
                          <ng-template #normalPostA>
                            <div *ngfor="let n; for: news[y]">
                              <app-post-medium
                                class="medium-post"
                                [routerLink]="['details/', editorial.id, n.id]"
                                [news_data]="news[y][i]"></app-post-medium>
                            </div>
                          </ng-template>
                        </ion-col>
                      </ion-row>
                    </div>
                    <div *ngIf="y >= 1">
                      <!-- outros banners -->
                      <ion-row>
                        <ion-col
                          size="12"
                          [sizeMd]="news[y].length < 3 ? 12 / news[y].length : 3"
                          data
                          *ngFor="let n of news[y] | slice: 0 : 4; let i = index">
                          <!-- Quando for o editorial Caminhos, usamos o wrapper para redirect -->
                          <ng-container *ngIf="editorial.id === EditorialCaminhosId; else normalPostB">
                            <ng-container *ngIf="newsCaminhosIntencionais.length > 0; else caminhosLoadingB">
                              <app-post-medium-redirect
                                [link]="newsCaminhosIntencionais[i].redirectLink"
                                [ariaLabel]="newsCaminhosIntencionais[i].title">
                                <app-post-medium class="medium-post" [news_data]="newsCaminhosIntencionais[i]"></app-post-medium>
                              </app-post-medium-redirect>
                            </ng-container>
                          </ng-container>
                          <ng-template #caminhosLoadingB>
                            <app-post-medium-loading class="medium-post"></app-post-medium-loading>
                          </ng-template>
                          <ng-template #normalPostB>
                            <app-post-medium
                              class="medium-post"
                              [routerLink]="['details/', editorial.id, n.id]"
                              [news_data]="news[y][i]"></app-post-medium>
                          </ng-template>
                        </ion-col>
                      </ion-row>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </app-news-card-list>
          </ion-col>
        </ion-row>
        <ion-row [hidden]="!Loading">
          <ion-col size="12">
            <app-news-card-list-loading class="main_banner">
              <div data class="loh wrap m fit" [hidden]="!LoadingHigh">
                <ion-col sizeLg="8" sizeMd="8" sizeXs="12">
                  <ion-skeleton-text class="full-width full-height skeleton-card" animated></ion-skeleton-text>
                </ion-col>
                <ion-col sizeLg="4" sizeMd="4" sizeXs="12" class="lov wrap ion-no-padding">
                  <div *ngFor="let high of fakeElements">
                    <app-post-medium-loading class="medium-post"></app-post-medium-loading>
                  </div>
                </ion-col>
              </div>
            </app-news-card-list-loading>
          </ion-col>
        </ion-row>
        <ion-row [hidden]="!Loading">
          <ion-col size="12">
            <app-news-card-list-loading class="secondary_banner" [hidden]="!Loading" [topbar]="true">
              <div data class="lov wrap m fit" [hidden]="!LoadingSecondary">
                <div *ngFor="let secondary of fakeElements">
                  <app-post-medium-loading class="medium-post"></app-post-medium-loading>
                </div>
              </div>
            </app-news-card-list-loading>
          </ion-col>
        </ion-row>

        <ion-row [hidden]="!Loading">
          <ion-col *ngFor="let secondary of fakeElements" sizeLg="4" sizeMd="4" sizeXs="12">
            <app-news-card-list-loading class="secondary_banner" [topbar]="true">
              <div data class="lov wrap m fit" [hidden]="!LoadingSecondary">
                <div *ngFor="let secondary of fakeElements">
                  <app-post-medium-loading class="medium-post"></app-post-medium-loading>
                </div>
              </div>
            </app-news-card-list-loading>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <ion-row class="ms" *ngIf="news[4]">
      <app-news-card-list
        title="{{ 'news.title.mostRecent' | translate }}"
        class="full-width"
        [route]="filter.Search ? 'news/null/' + filter.CategoryId + '/' + filter.Search : 'news/null/' + filter.CategoryId + '/undefined'"
        [color]="'var(--ion-color-primary)'"
        [categories]="true"
        [hidden]="Loading"
        [notFound]="recentsNotFound"
        [empty]="empty"
        [moreButton]="news[4].length < 6 ? false : true"
        [dashboard]="true">
        <div data class="fit">
          <ion-row class="jc">
            <ion-col
              class="medium-post loh center"
              *ngFor="let n of news[4] | slice: 0 : 6; let i = index"
              [hidden]="LoadingNews"
              sizeLg="5.5"
              sizeMd="5.7"
              sizeXs="12">
              <div class="vertical-line"></div>
              <app-post-large
                class="full-width post-large-full-height"
                [hidden]="recentsLoading || recentsNotFound || empty"
                [routerLink]="['details/null', n.id]"
                [news_data]="news[4][i]">
              </app-post-large>
            </ion-col>
          </ion-row>
        </div>
      </app-news-card-list>

      <app-news-card-list-loading class="full-width" [categories]="true" [hidden]="!Loading">
        <div data class="m fit">
          <ion-row>
            <ion-col *ngFor="let news of fakeElementsLarg" sizeLg="5.5" sizeMd="5.7" sizeXs="12">
              <app-post-medium-loading></app-post-medium-loading>
            </ion-col>
          </ion-row>
        </div>
      </app-news-card-list-loading>
    </ion-row>
  </main>
</ion-content>
